module.exports = __webpack_public_path__ + "static/media/panicum-mombaca.23c9aff3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/panicum-mombaca.jpg
// module id = 96
// module chunks = 0